import { render, staticRenderFns } from "./ResetPassModal.vue?vue&type=template&id=1bd80a5c&scoped=true"
import script from "./ResetPassModal.vue?vue&type=script&lang=js"
export * from "./ResetPassModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd80a5c",
  null
  
)

export default component.exports